<template>
    <UiCarousel v-editable="blok" :blok="blok" :class="{ 'zero-padding': blok.full_width }" />
</template>

<script setup>
defineProps({ blok: Object });
</script>

<style lang="postcss" scoped>
.carousel-section {
    :deep(.container.full-width) {
        @apply px-0;
    }
    &.zero-padding {
        @apply px-0;
    }

    &.navigation-circle {
        :deep(.carousel) {
            .carousel__next {
                i:before {
                    content: '\f054';
                }
            }
            .carousel__prev {
                i:before {
                    content: '\f053';
                }
            }
        }
    }
    :deep(.full-width) {
        .carousel {
            @apply mx-0;
        }
        .carousel .carousel__prev {
            @apply ml-0;
        }
        .carousel .carousel__next {
            @apply mr-0;
        }
        .carousel__viewport {
            @apply md:-mx-1 md:w-auto md:min-w-full;
        }
    }

    :deep(.carousel) {
        @apply mx-0 md:mx-[9%] lg:mx-[7%];

        .carousel__slide {
            @apply pb-4;
            img {
                @apply w-full;
            }
        }
        .carousel__next,
        .carousel__prev {
            @apply bg-[#f6ab2f] w-[42px] h-[42px] border-0 rounded-[inherit] transition duration-300 ease-in-out;

            &:hover {
                @apply bg-[#055988];
            }

            .iconify {
                @apply h-[25px] text-white;
            }
        }
        .carousel__next {
            @apply mr-0 md:mr-[-12%] lg:mr-[-7%];
        }
        .carousel__prev {
            @apply ml-0 md:ml-[-12%] lg:ml-[-7%];
        }
    }
}
</style>
